// assets
import { IconKey, IconPhone } from '@tabler/icons-react';

// constant
const icons = {
    IconKey,
    IconPhone
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
    id: 'pages',
    title: 'ارتباط با وجوهات',
    // caption: 'ارتباط با وجوهات',
    type: 'group',
    children: [
        {
            id: 'contact',
            title: 'تماس با پشتیبانی',
            type: 'collapse',
            icon: icons.IconPhone,
            children: [
                {
                    id: 'social',
                    title: 'شبکه‌های اجتماعی',
                    type: 'item',
                    url: '/social'
                },
                {
                    id: 'tel',
                    title: 'خطوط ارتباطی',
                    type: 'item',
                    url: '/tel'
                }
            ]
        }
    ]
};

export default pages;
